
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"17.6","height":"18.6","x":"1.2","y":"1.2","stroke":"currentColor","stroke-width":"2.4","rx":"2"}}),_c('g',{attrs:{"transform":"translate(4.828 4.9)"}},[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-width":"2.4","d":"M.94 7.467h8.631"}}),_c('ellipse',{attrs:{"cx":"2.351","cy":"2.333","fill":"currentColor","rx":"2.351","ry":"2.333"}})])])])
          )
        }
      }
    